export let Status;

(function (Status) {
  Status["Active"] = "active";
  Status["Archived"] = "archived";
})(Status || (Status = {}));